import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { useNavigate, useRouteError } from 'react-router-dom';
import MagicBriefLogo from 'src/assets/svgicons/magicbrief/MagicBriefLogo.svg';
import { AriaBaseButton } from 'src/components/Button/BaseButton';
import Navigation from 'src/components/Navigation/Navigation';
import useNewAnalyticsEvent from 'src/utils/useNewAnalyticsEvent';
import DefaultFallback from './components/DefaultFallback/DefaultFallback';

const MagicBriefRouterErrorBoundary: React.FunctionComponent =
  (): JSX.Element => {
    const error = useRouteError() as Error;
    const navigate = useNavigate();
    const { recordEvent } = useNewAnalyticsEvent();

    useEffect(() => {
      Sentry.captureException(error, {
        level: 'fatal',
        contexts: {
          opts: {
            componentStack: error.stack,
          },
        },
      });

      void recordEvent({ target: 'User', action: 'Viewed Error Page' });
    }, [error, recordEvent]);

    return (
      <div className="flex min-h-full flex-col gap-16 bg-white">
        <Navigation.Base mobileMenu={null}>
          <AriaBaseButton
            onPress={() => {
              navigate('/');
            }}
          >
            <MagicBriefLogo className="h-7 max-w-[133px]" />
          </AriaBaseButton>
        </Navigation.Base>
        <DefaultFallback error={error} />
      </div>
    );
  };

export default MagicBriefRouterErrorBoundary;
